import { FullResourceFragment } from "~/graphql/codegen/graphql";
import { useEffect, useState } from "react";
import { graphql } from "~/graphql/codegen";
import { useSubscription } from "@apollo/client/react";

const RESOURCE_UPDATED_SUBSCRIPTION = graphql(`
  subscription ResourceUpdated($id: ID!) {
    resourceUpdated(id: $id) {
      ...FullResource
    }
  }
`);

export const useArticle = (loadedResource?: FullResourceFragment | null) => {
  const [article, setArticle] = useState<FullResourceFragment | null>(
    loadedResource || null,
  );

  useEffect(() => {
    if (loadedResource) {
      setArticle(loadedResource);
    }
  }, [loadedResource]);

  useSubscription(RESOURCE_UPDATED_SUBSCRIPTION, {
    variables: {
      id: loadedResource?.id || "",
    },
    onData: (res) => {
      const updatedArticle = res.data.data?.resourceUpdated;
      if (!updatedArticle) {
        console.error("Updated Article:", res.data.error);
        return;
      }
      setArticle(updatedArticle);
    },
  });

  return article;
};
